'use strict';

module.exports = '3.26.0';
